<template>
  <div class="sidebar-edit-popover-folder-form">
    <TirPmInput
      v-model="folderName"
      label="Название папки"
      placeholder="Новая папка"
      :is-with-error="!!errorMessage"
      :is-show-hint="!!errorMessage"
      auto-select
    >
      <template #hintMessage>
        {{ errorMessage }}
      </template>
    </TirPmInput>
    <TirPmButton
      :variant="TirPmButtonVariantEnum.PrimaryState"
      :size="TirPmButtonSizeEnum.Small"
      @click="onClick"
    >
      Сохранить
    </TirPmButton>
  </div>
</template>

<script lang="ts" setup>
import { PropType, ref } from "vue";
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmInput,
} from "tir-components";
import { AdapterService } from "../adapter";
import { GroupModel, UpdateGroupNameModel } from "../models";

const emit = defineEmits<{
  /**Событие при обновлении группы */
  (e: "onUpdate", group: GroupModel): void;
}>();

const props = defineProps({
  /**Информация о редактируемой группе */
  group: {
    type: Object as PropType<GroupModel>,
    required: true,
  },
});

const adapter = new AdapterService();

/**Название папка */
const folderName = ref(props.group.Name ?? "");
/**Сообщение об ошибке */
const errorMessage = ref("");

/**
 * * Валидация формы
 */
const validate = () => {
  if (!folderName.value.trim()) {
    errorMessage.value = "Введите название папки";
    return false;
  }

  return true;
};

/**
 * * Сброс состояния формы
 */
const resetForm = () => {
  folderName.value = props.group.Name ?? "";
};

const onClick = async () => {
  if (!validate()) return;

  const request = new UpdateGroupNameModel({
    GroupId: props.group.Id,
    Name: folderName.value,
  });

  const resp = await adapter.updateGroupName(request);

  if (!resp.IsSuccess) {
    resetForm();
    return;
  }

  const group = new GroupModel({
    ...props.group,
    Name: request.Name,
  });

  emit("onUpdate", group);
};
</script>

<style lang="scss" scoped>
.sidebar-edit-popover-folder-form {
  display: flex;
  flex-direction: column;
  padding: 0.75rem;
}
</style>
